import {loadFormAppJS} from 'app/components/formReference/loadFormAppJS';
import {appEvents} from 'app/utils/appEvents';
import {type GemSettings} from 'app/utils/config/interface';
import {triggerCustomEvent} from 'app/utils/jqueryNative';

export const importJSI = () => import(/* webpackChunkName: "JSI" */ 'JSI');
export async function loadJSI(formAppPath?: string, signal?: AbortSignal) {
    if (!window.JSI) {
        throw new ReferenceError('window.JSI is missing!');
    }

    let formAppScript: HTMLScriptElement | undefined;
    if (formAppPath) {
        formAppScript = await loadFormAppJS(formAppPath, signal);
    }

    window.JSI.components = await importJSI();

    triggerCustomEvent(document, appEvents.jsiCompleted);

    return formAppScript;
}

export const initJSI = (gemSettings: GemSettings) => () => {
    window.JSI = {
        settings: gemSettings,
    };
};
